import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {PopoverMultiSelectObjectBaseComponent} from '../_base/popover-multi-select-object-base.component';
import {AppsService} from '../../../../../core/services/apps.service';
import {App, APP_TYPE_PICTURE} from '../../../../../shared/models/app';
import {Option, OptionGroupMultiSelect} from '../../../../../shared/models/option';
import {TileId} from '../../../../../shared/models/tile';
import {Observable, of} from 'rxjs';
import {PopoverMultiSelectComponent} from '../../popover-multi-select.component';
import {catchError} from 'rxjs/operators';

@Component({
  selector: 'motn-popover-select-apps',
  templateUrl: './popover-select-apps.component.html',
  styleUrls: ['./popover-select-apps.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    PopoverMultiSelectComponent,
  ],
})
export class PopoverSelectAppsComponent extends PopoverMultiSelectObjectBaseComponent implements OnInit {
  /**
   * If provided and optionGroup is not provided, then the apps whose Tiles arrays
   * include this TileId will be rendered as selected automatically
   */
  @Input() preselectAppsWithTileId: TileId;
  /**
   * Optional. Supply if there should only be a subset of apps smaller than all the
   * user's apps to select from.
   */
  @Input() apps: App[];

  loading = false;


  constructor(
    private appsService: AppsService,
  ) {
    super();
  }


  protected onInit() {
    this.optionGroup$ = new Observable<OptionGroupMultiSelect>(
      subscriber => {
        if (this.optionGroupIsPrepared()) {
          this.initSubscriberHandle(subscriber);
        } else if (!this.apps) {
          this.appsService.fetchUserApps$().subscribe({
            next: (apps) => {
              this.apps = apps.filter(app => app.Type === APP_TYPE_PICTURE);
              this.prepareOptionGroup(subscriber);
            },
            error: err => subscriber.error(err),
          });
        } else {
          this.prepareOptionGroup(subscriber);
        }
      }
    );
  }


  onSelectApp($event: Option) {
    if ($event) {
      this.clickedOption$.emit($event);
    }
  }


  protected prepareOptionGroup(subscriber?: any): OptionGroupMultiSelect {
    if (this.preselectAppsWithTileId) {
      this.loading = true;
      this.optionGroup = new OptionGroupMultiSelect([]);
      this.appsService.getAppsLinkedToTile$(this.preselectAppsWithTileId).pipe(
        catchError(() => of([]))
      ).subscribe(linkedApps => {
        const linkedAppIds = new Set(linkedApps.map((app: App) => app.ID));
        this.createOptionGroupWithApps(linkedAppIds);
        this.loading = false;
        if (subscriber) {
          this.initSubscriberHandle(subscriber);
        }
      });
    } else {
      this.createOptionGroupWithApps(new Set());
      this.loading = false;
      if (subscriber) {
        this.initSubscriberHandle(subscriber);
      }
    }
    
    return this.optionGroup;
  }

  private createOptionGroupWithApps(selectedAppIds: Set<string>) {
    const options = this.apps.map(app => ({
      id: app.ID,
      name: app.Name,
      selected: selectedAppIds.has(app.ID),
    }));

    this.optionGroup = new OptionGroupMultiSelect(options);
    this.optionGroup.saveInitialSelection();
  }
}
